import { render } from "./NoticeUpdateItems.vue?vue&type=template&id=5b3e9b4e&scoped=true"
import script from "./NoticeUpdateItems.vue?vue&type=script&lang=js"
export * from "./NoticeUpdateItems.vue?vue&type=script&lang=js"

import "./NoticeUpdateItems.vue?vue&type=style&index=0&id=5b3e9b4e&scoped=true&lang=css"
import "./NoticeUpdateItems.vue?vue&type=style&index=1&id=5b3e9b4e&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3e9b4e"]])

export default __exports__